export default __webpack_public_path__ + "assets/images/a4f6617e45d8c1fd345c7dd6d745f25a.png";